import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import AuthService from "../../../../services/AuthService";
import MembersApi from '../../../../services/portal-api/MembersApi';

export default class GiftcardInfo extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isloadingHistory: false,
            cardHistory: null,
        }
    }

    componentDidMount() {
        this._showHistory();
    }

    convertUTCToLocalTime = (dateString) => {
        let date = new Date(dateString);
        const milliseconds = Date.UTC(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            date.getHours(),
            date.getMinutes(),
            date.getSeconds(),
        );
        const localTime = new Date(milliseconds);

        let cd = localTime.getFullYear() + "-" + (localTime.getMonth() + 1) + "-" + localTime.getDate() + " " + localTime.getHours() + ":" + localTime.getMinutes() + ":" + localTime.getSeconds();
        return moment(cd).format('DD/MM/YYYY h:mm A');
    };

    convert24To12Hours = (dateString) => {
        return moment(dateString).format('DD/MM/YYYY h:mm A');
    }

    _showHistory = () => {
        MembersApi.getCardHistory((response) => {
            //console.log(response);
            if (response.success) {
                this.setState({ cardHistory: response.json.history.history }, () => { console.log(this.state) });
            } else {

            }
        }, this.props.cardNumber);
    }

    render() {
        // Error
        if (this.props.error !== undefined && this.props.error !== null) {
            //this.props["errorDetail"] = "Invalid gift card number format";

            let error_details = {
                "Invalid gift card number format": {
                    'admin': "The card number you have entered is not in the correct format. Please renter the number and try again",
                    'user': "The card number you have entered is incorrect. Please renter the number and try again"
                },
                "Gift card not found": {
                    'admin': "The Gift Card number you have entered is incorrect or does not exist. Please renter the number and try again",
                    'user': "The Gift Card number you have entered is incorrect or does not exist. Please renter the number and try again"
                },
                "On Hold": {
                    'admin': "This card number has been put on hold in Givex. Please remove the hold in the Givex portal in order to use it. Lookups are unavailable at this time.",
                    'user': "This card number is currently suspended and lookups are unavailable at this time. Please contact Loyalty Support for further assistance."
                },
                // "Not Activated" : {
                //     'admin' : "This card number has not been activated yet. It will need to be activated in Givex in order to be used.",
                //     'user'  : "This card number has not been activated yet. Please contact Loyalty Support for further assistance."
                // },
                "Not Activated": {
                    'admin': "This card number has not been activated. If you believe it should be active, then please contact your Area Manager for approval to process it as an Emergency Gift Card Redemption, otherwise contact help@dusk.com.au for further assistance.",
                    'user': "This card number has not been activated. If you believe it should be active, then please contact your Area Manager for approval to process it as an Emergency Gift Card Redemption, otherwise contact help@dusk.com.au for further assistance."
                }
            }

            return (
                <div className="container max-width--500 text--18">
                    <h3 className="text--orange text--light text--26 margin--20--bot">{this.props.error}</h3>
                    <p>
                        {AuthService.isAdmin() && error_details[this.props.error] !== undefined && <React.Fragment> {error_details[this.props.error].admin} </React.Fragment>}
                        {!AuthService.isAdmin() && error_details[this.props.error] !== undefined && <React.Fragment> {error_details[this.props.error].user} </React.Fragment>}
                        {error_details[this.props.error] == undefined && <React.Fragment> {this.props.errorDetail} </React.Fragment>}
                    </p>
                </div>
            )
        }
        // Nothing submitted
        if (typeof this.props.cardNumber === 'undefined') {
            return null;
        }
        // Card found
        let expiryDate = '-';
        if (this.props.expiryDate !== null) {
            expiryDate = moment(this.props.expiryDate).format('D MMMM YYYY');
        }
        let dotClass = 'dot dot--lime';
        if (this.props.status === 'Redeemed') {
            dotClass = 'dot dot--yellow';
        }
        else if (this.props.status === 'Expired') {
            dotClass = 'dot dot--red';
        }

        let balance_default = '';
        let balance_other = '';
        //console.log(this.props.currency);
        if (this.props.balance != null) {
            balance_default = this.props.balance.split("|")[0];
            balance_other = this.props.balance.split("|")[1];
        }
        let currency_default = '';
        let currency_other = '';
        if (this.props.balance != null) {
            currency_default = this.props.currency.split("|")[0];
            currency_other = this.props.currency.split("|")[1];
        }

        const currencyStyle = {
            color: "grey",
            fontSize: 23
        };
        let histry = [];
        this.state.cardHistory != null && this.state.cardHistory.forEach((row, ky) => {
            let columns = []; let dateString = '';
            row.forEach((col, u) => {
                if (u == 0) {
                    dateString = col;
                    return;
                } else if (u == 1) {
                    dateString += " " + col;
                }

                columns.push(<div className="widget--giftcard__result balance" key={u}>
                    {/* <h3 className="sub-title" style={{color:"#4b5053"}}>{u == 1 ? this.convertUTCToLocalTime(dateString): col}</h3> */} {/* was converting to browser time from utc*/}
                    <h3 className="sub-title" style={{ color: "#4b5053" }}>{u == 1 ? this.convert24To12Hours(dateString) : col}</h3> {/* Now only converting from 24 hours to 12 hours and showing as it is from Givex*/}
                </div>);
            });
            if(AuthService.can('Gift card history')) {
                histry.push(<div className="widget--giftcard__table_row" key={ky} style={{ display: "table-row" }}>{columns}</div>);
            }
        });
        histry.length > 0 && histry.unshift(<div className="widget--giftcard__table_row" key="transationHeader" style={{ display: "table-row" }}>
            <div className="widget--giftcard__result balance" key="0"><h3 className="sub-title text--muted">Purchase Date</h3></div>
            <div className="widget--giftcard__result balance" key="1"><h3 className="sub-title text--muted">Status</h3></div>
            <div className="widget--giftcard__result balance" key="2"><h3 className="sub-title text--muted">Amount</h3></div>
            <div className="widget--giftcard__result balance" key="3"><h3 className="sub-title text--muted">Givex Store</h3></div>
        </div>);

        return (
            <div>

                <div className="widget--giftcard__result cardnumber">
                    <h3 className="sub-title text--muted">Card number</h3>
                    <p className="text--30">{this.props.cardNumber}</p>
                </div>

                <div className="widget--giftcard__table">
                    <div className="widget--giftcard__result balance">
                        <h3 className="sub-title text--muted">Remaining balance</h3>
                        <p className="text--30">

                            {(currency_default || '').trim() != (currency_other || '').trim() && <React.Fragment>
                                <span style={currencyStyle}>{currency_default} </span> {balance_default} <br /> <span style={currencyStyle}>{currency_other} </span> {balance_other}
                            </React.Fragment>}
                            {(currency_default || '').trim() == (currency_other || '').trim() && <React.Fragment>
                                <span style={currencyStyle}>{currency_default} </span> {balance_default}
                            </React.Fragment>}
                            {this.props.preAuthBalance !== '0.00' &&
                                <span className="preauth text--15"><br />+ {this.props.currency}{this.props.preAuthBalance} Pre-Authed</span>
                            }
                        </p>
                    </div>

                    <div className="widget--giftcard__result expiry">
                        <h3 className="sub-title text--muted">Expiry date</h3>
                        <p className="text--30">{expiryDate}</p>
                    </div>

                    <div className="widget--giftcard__result status">
                        <h3 className="sub-title text--muted">Status</h3>
                        <p className="text--30"><span className={dotClass} /> {this.props.status}</p>
                    </div>
                </div>
                {this.state.cardHistory != null && <React.Fragment>
                    <div className="widget--giftcard__table margin--30--top margin--30--bot" style={{ borderTop: '2px solid #f1f1f1' }}>
                    </div>
                    <div className="widget--giftcard__table">
                        {histry}
                    </div>
                </React.Fragment>}
            </div>
        )
    }
}

GiftcardInfo.propTypes = {
    error: PropTypes.string,
    errorDetail: PropTypes.string,
    cardNumber: PropTypes.string,
    balance: PropTypes.string,
    preAuthBalance: PropTypes.string,
    expiryDate: PropTypes.string,
    status: PropTypes.string
};
